/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatientProblems from '../reducer/patient-problem.reducer';

export const patientProblemsFeatureSelector = createFeatureSelector<fromPatientProblems.PatientProblemsState>(
  fromPatientProblems.patientProblemsFeatureKey
);

const { selectEntities, selectAll } = fromPatientProblems.patientProblemsAdapter.getSelectors();

export const selectPatientProblemEntities = createSelector(patientProblemsFeatureSelector, selectEntities);

export const selectPatientProblems = createSelector(patientProblemsFeatureSelector, selectAll);

export const selectCurrentCount = createSelector(
  selectPatientProblems,
  patientProblems => patientProblems?.length ?? 0
);

export const selectError = createSelector(patientProblemsFeatureSelector, state => state.baseState.error);

export const selectIsLoading = createSelector(patientProblemsFeatureSelector, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(patientProblemsFeatureSelector, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(patientProblemsFeatureSelector, state => state.pageSize);

export const selectIsAtEndOfData = createSelector(
  patientProblemsFeatureSelector,
  state => state.baseState.isAtEndOfData
);

export const selectTotalRecordCount = createSelector(
  patientProblemsFeatureSelector,
  state => state.baseState.totalRecordCount ?? 0
);

export const selectIsFullDatasetLoaded = createSelector(
  patientProblemsFeatureSelector,
  state => state?.isFullDatasetLoaded ?? false
);

export const selectCachePatientId = createSelector(
  patientProblemsFeatureSelector,
  state => state?.cachePatientId ?? null
);

export const selectCacheLoadedAt = createSelector(
  patientProblemsFeatureSelector,
  state => state?.cacheLoadedAt ?? null
);

export const selectIsFullDatasetLoading = createSelector(
  patientProblemsFeatureSelector,
  state => state?.isFullDatasetLoading ?? false
);

export const selectFullDatasetError = createSelector(
  patientProblemsFeatureSelector,
  state => state?.fullDatasetError ?? null
);
